import React from "react";
import { withRouter } from "../react/WithRouter";

import ExcelJS from "exceljs";
import saveAs from "file-saver";

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MultiSelect } from 'primereact/multiselect';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Toolbar } from 'primereact/toolbar';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';

import UserContext from '../../context/UserContext';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare, faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";


class AdmOrg extends React.Component {
	static contextType = UserContext;

	state = {
		isLoadingData: true,
		orgList: [],
	};

	constructor(props) {
		super(props);
		//this.dataTableRef = React.createRef();

	}

	componentDidMount() {
		this.fetchControlList();
	}

	fetchControlList() {
		this.setState({ isLoadingData: true });
		
		fetch(`api/Organisation/AllOrgs`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.setState({ orgList: data });
				this.setState({ isLoadingData: false });
			})
			.catch(error => {
				this.setState({ isLoadingData: false });
			})
	}

	dateBodyTemplate(rowData) {
		return rowData.controlDate.toLocaleDateString('sv-SE', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric'
		});
	}

	newModal() {		
		const footerContent = (
			<div>
				<Button variant="primary" onClick={() => {  }}>Create</Button>
				<Button variant="secondary" onClick={() => {  }}>Cancel</Button>
			</div>
		);

		return (
			<Dialog header="Create new organisation" visible={this.state.openModal === 'new'} style={{ width: '50vw' }} onHide={() => this.setState({ modalWindow: '' })} closable={false} footer={footerContent}>
				<div className="p-fluid">
					<div className="p-field">
						<label className="p-field-label">Name</label>
						<InputText
							value={this.state.ModalCreateName}
							placeholder="Enter company name"
							onChange={e => this.setState({ ModalCreateName: e.target.value })}
							disabled={this.state.isModalLoading}
							maxLength="64"
						/>
					</div>
					<div className="p-field">
						<label className="p-field-label">VAT</label>
						<InputText
							value={this.state.ModalCreateAddress}
							placeholder="Enter company name"
							onChange={e => this.setState({ ModalCreateAddress: e.target.value })}
							disabled={this.state.isModalLoading}
							maxLength="11"
						/>
					</div>
					<div className="p-field">
						<label className="p-field-label">Address</label>
						<InputTextarea
							value={this.state.ModalCreateAddress}
							placeholder="Enter company name"
							onChange={e => this.setState({ ModalCreateAddress: e.target.value })}
							disabled={this.state.isModalLoading}
							rows={5} cols={30}
							maxLength="64"
						/>
					</div>
				</div>
			</Dialog>
		);
	}

	render() {
		const leftTools = (
			<div style={{ textAlign: 'middle' }}>
				
			</div>
		);

		const rightTools = (
			<div>
				<Button className="p-button-sm" onClick={() => null} ><FontAwesomeIcon icon={faPlusSquare}/> &nbsp;Add organisation</Button>
			</div>
		);

		const toolbar = (
			<Toolbar className="mb-0" start={leftTools} end={rightTools}></Toolbar>
		);

		return (
			<div style={{ width: '100%', overflow: 'auto', height: '100%' }}>
					<DataTable
					loading={this.state.isLoadingData}
					ref={this.dataTableRef}
					value={this.state.orgList}
					tableStyle={{ minWidth: '50rem', width: '100%' }}
					size="small"
					removableSort
					header={toolbar}
					scrollable
					scrollHeight="flex"
					resizableColumns showGridlines
					emptyMessage="No organisations found."
					selectionMode="single"
					
				>
						< Column
							field="orgID"
							header="OrgID"
							sortable
						style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexBasis: '5rem', minWidth: '5rem', maxWidth: '8rem' }}
							
						>
					</Column>
					< Column
						field="name"
						header="Organisation"
						sortable
						style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexBasis: '7rem', minWidth: '11rem' }}

					>
					</Column>
				</DataTable>
			</div>
		);
	}
}
/*
 filters={this.state.filters}
filterDisplay="menu"
onValueChange={filteredData => this.setState({ filteredData: filteredData })}
					 
					 
filter
filterElement={this.templateFilterTemplate.bind(this)}
showFilterMatchModes={false}
*/
export default withRouter(AdmOrg);